import { useQuery } from "react-query";
import { getDistributionChannelList } from "../../../../../actions/Utilities/DistributionChannel";

export const useGetDistributionChannel = () => {
  const { data, isFetching } = useQuery(
    "GetDistributionChannelList",
    getDistributionChannelList,
    {
      refetchOnWindowFocus: false,
    }
  );
  return { data, isFetching };
};
